import { Button } from '@doda/io-react/common';
import { FC } from 'react';
import styles from './index.module.scss';

/**
 * Propsの定義
 * @param onClickSearch この条件で検索する処理
 * @param onClickClear 設定をクリアする処理
 */
interface Props {
  onClickSearch: () => void;
  onClickClear: () => void;
}

export const SearchButton: FC<Props> = ({ onClickSearch, onClickClear }) => {
  return (
    <div className={styles.jobSearchTop__searchBtnWrap}>
      <Button as="button" onClick={onClickSearch} size="L" variant="green">
        この条件で検索する
      </Button>
      <button
        className={styles.jobSearchTop__allClearBtn}
        type="button"
        onClick={onClickClear}
      >
        設定をクリア
      </button>
    </div>
  );
};
